import styles from "../../../styles/PaymentForm.module.scss";
import {
  useElements,
  useStripe,
  PaymentElement,
} from "@stripe/react-stripe-js";
import useLocalStorage from "../../../hooks/useLocalStorage";
import {
  STRIPE_PRODUCTS_LS_ID,
  DISEASE_LS_ID,
  STRIPE_INFO,
  STRIPE_SELECTED_PRODUCT_LS_ID,
} from "../constants";
import { useMemo, useState } from "react";
import { getStripeProductFromDiseases, applyDiscount } from "../../../utils/liberals";
import SummaryCard from "../informations/SummaryCard";
import Line from "../informations/Line";
import { LoadableText } from "../../UI/LoadableText";

const PaymentForm = ({ nextStep = () => {} }) => {
  const [localStorageProducts] = useLocalStorage(STRIPE_PRODUCTS_LS_ID, []);
  const [localStorageDiseases, setLocalStorageDiseases] = useLocalStorage(DISEASE_LS_ID, []);
  const [localStorageSelectedProduct, setLocalStorageSelectedProduct] = useLocalStorage(STRIPE_SELECTED_PRODUCT_LS_ID, {});
  const [stripeInfo] = useLocalStorage(STRIPE_INFO, null);
  const [submiited, setSubbmitted] = useState(false);

  const stripe = useStripe();
  const elements = useElements();

  const selectedProduct = useMemo(
    () =>
      applyDiscount(getStripeProductFromDiseases(
        localStorageProducts,
        localStorageDiseases
      ), stripeInfo?.discount),
    [localStorageProducts, localStorageDiseases]
  );

  async function onSubmit(event) {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setSubbmitted(true);

    const { error } = await stripe.confirmPayment({
      elements,
      redirect: "if_required"
    });

    if (error) {
      alert("Une erreur est survenue lors du paiement");
      console.error(error);
      setSubbmitted(false);
    } else {
      if (localStorageDiseases?.length > 0) {
        setLocalStorageDiseases([]);
      }
      if (localStorageSelectedProduct?.id) {
        setLocalStorageSelectedProduct({});
      }
      nextStep();
    }
  }

  return (
    <div className={styles.layoutContainer}>
      <SummaryCard title="Votre paiement" styles={styles}>
        <div className={styles.cardPart} style={{ padding: "16px" }}>
          <PaymentElement
            options={{
              layout: {
                type: "accordion",
                radios: true,
              },
            }}
          />
        </div>
        <div className={styles.buttonContainer}>
          <button className={styles.submitButton} onClick={onSubmit} disabled={!stripe || !elements || submiited}>
            {submiited ? "En cours de traitement..." : "Valider le paiement"}
          </button>
        </div>
      </SummaryCard>
      <SummaryCard title="Récapitulatif de votre commande" styles={styles}>
        <div className={styles.cardPart}>
          <Line subtitle="Offre :" styles={styles}>
            <div>{selectedProduct.name}</div>
          </Line>
          <Line subtitle="Thématiques :" styles={styles}>
            <ul className={styles.list}>
              {localStorageDiseases.map(
                (disease) =>
                  disease && (
                    <li
                      key={disease.id}
                      style={{ color: "#145A79" }}
                    >
                      <LoadableText text={disease.name} />
                    </li>
                  )
              )}
            </ul>
          </Line>
          {stripeInfo?.discount && (
            <Line subtitle="Code de réduction" styles={styles}>
              <div className={styles.discount}>
                {stripeInfo.discount.discount_code}: - {stripeInfo.discount.amount_off ?? stripeInfo.discount.percent_off}
                {stripeInfo.discount.amount_off ? "€" : "%"}
              </div>
            </Line>
          )}
        </div>

        <div className={styles.cardPart}>
          <Line subtitle="Montant" details="HT" styles={styles}>
            <div className={styles.price}>
              <LoadableText text={selectedProduct.localized_price_subtaxes} />
            </div>
          </Line>

          <Line subtitle="TVA" details="20%" styles={styles}>
            <div className={styles.price}>
              <LoadableText text={selectedProduct.localized_price_taxes} />
            </div>
          </Line>

          <Line subtitle="Total" details="T.T.C" styles={styles}>
            <div className={styles.price}>
              <LoadableText text={selectedProduct.localized_price} />
            </div>
          </Line>

          <div className={styles.subtitle}>Nous acceptons :</div>
          <div className={styles.imgContainer}>
            <img src="/images/liberals/payment/cb.png" alt="CB" />
            <img src="/images/liberals/payment/sepa.png" alt="SEPA" />
          </div>
        </div>
      </SummaryCard>
    </div>
  );
};

export default PaymentForm;
